var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$vuetify.breakpoint.mobile)?_c('mobile-placeholder'):_c('div',[_c('base-modal',{ref:"confirm"}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }